module.exports = __webpack_public_path__ + "img/img_works08.875011c7.jpg";